{
  "index": {
    "title": "Projects",
    "newProject": "New project",
    "catalog": "Project catalog",
    "badges": {
      "view": "View",
      "access": "Access",
      "settings": "Settings",
      "demo": "Demo"
    },
    "progress": "Progress",
    "createdAt": "Created: {{date}}",
    "empty": {
      "title": "No projects yet",
      "description": "Create your first project in the wizard"
    },
    "wizard": "Creation wizard",
    "noCover": "No cover"
  },
  "home": {
    "inWork": "In progress",
    "inWorkHint": "Favorites and the most recently active",
    "recentGenerations": "Recent generations",
    "recentGenerationsHint": "Canvas and shots across all projects",
    "cast": "Characters",
    "castHint": "Heroes of the projects in progress",
    "allProjects": "All projects",
    "allProjectsCount": "{{count}} projects",
    "filterPlaceholder": "Find a project…",
    "filterEmpty": "Nothing found",
    "lastShot": "Shot {{label}}",
    "activity": "active {{when}}",
    "noActivity": "No activity yet",
    "openCharacter": "{{name}} — open in characters of “{{project}}”"
  },
  "card": {
    "copyToCompany": "Copy to company",
    "addFavorite": "Add to favorites",
    "removeFavorite": "Remove from favorites",
    "menuAria": "Project actions",
    "copy": "Copy",
    "share": "Share",
    "archive": "Archive"
  },
  "errors": {
    "favoriteFailed": "Could not update favorites"
  },
  "announcements": {
    "dismiss": "Dismiss announcement"
  },
  "copyDialog": {
    "title": "Copy project",
    "source": "Source: “{{name}}”",
    "close": "Close",
    "targetCompany": "Target company",
    "selectCompany": "Select company…",
    "copyName": "Copy name",
    "copyNamePlaceholder": "New copy",
    "note": "The whole project is copied (including prompt overrides). Assets are duplicated within ActiveStorage; external services are not called.",
    "cancel": "Cancel",
    "submit": "Start copying",
    "copySuffix": "{{name}} (copy)"
  },
  "shareDialog": {
    "title": "Share project",
    "source": "Project: “{{name}}”",
    "close": "Close",
    "company": "Company",
    "selectCompany": "Select company…",
    "accessLevel": "Access level",
    "accessSettings": "Settings and content",
    "accessContent": "Content (no settings)",
    "accessView": "View only",
    "cancel": "Cancel",
    "submit": "Share"
  },
  "wizard": {
    "headTitle": "New project",
    "title": "New project",
    "projectTypes": {
      "heading": "Project type",
      "hint": "The type defines the workflow, sections, and terms. It cannot be changed after creation.",
      "serial": {
        "title": "Series",
        "description": "Full production pipeline for studios and productions.",
        "structure": "Seasons → Episodes → Scenes → Shots"
      },
      "stories": {
        "title": "Stories / Reels",
        "description": "Short vertical content: Canvas and Storyboard without extra entities.",
        "structure": "Reels"
      },
      "commercial": {
        "title": "Commercial",
        "description": "Same pipeline as a series, with agency terminology.",
        "structure": "Campaigns → Spots → Scenes → Shots"
      },
      "short_film": {
        "title": "Short film",
        "description": "One film: scenes and shots without seasons and episodes.",
        "structure": "Scenes → Shots"
      }
    },
    "nameLabel": "Name",
    "namePlaceholder": "e.g. Neon Floor",
    "storyLabel": "Idea / logline",
    "storyPlaceholder": "Briefly: who, conflict, hook for vertical format…",
    "teamLabel": "Project team",
    "teamHint": "Who to add to the project. Selected people get the Contributor role.",
    "teamAssignAll": "Assign everyone",
    "seasonsLabel": "Seasons",
    "campaignsLabel": "Ad campaigns",
    "episodesPerSeasonLabel": "Episodes per season",
    "spotsPerCampaignLabel": "Spots per campaign",
    "reelsCountLabel": "Number of reels",
    "episodeDurationLabel": "Episode duration (sec, max 600)",
    "spotDurationLabel": "Spot duration (sec, max 600)",
    "reelDurationLabel": "Reel duration (sec, max 600)",
    "filmDurationLabel": "Film duration (sec, max 600)",
    "summaryType": "Type:",
    "summaryFormatStories": "{{reels}} reel(s), {{duration}}s each",
    "summaryFormatShortFilm": "Film ~{{duration}}s",
    "genreLabel": "Genre",
    "narrativeToneLabel": "Narrative tone",
    "sectionStructure": "Structure & story",
    "sectionVisual": "Visual style",
    "sectionMedium": "Visual medium",
    "generationParamsTitle": "Generation parameters",
    "generationParamsEmpty": "Default settings",
    "frameFormatLabel": "Frame format",
    "frameFormatHint": "One format for the whole series: applies to all storyboard and video APIs, and to previews in the production block.",
    "genrePlaceholder": "Select a genre…",
    "tonePlaceholder": "Select a narrative tone…",
    "mediumPlaceholder": "Select a medium from the catalog",
    "mediumSearchPlaceholder": "Search catalog…",
    "catalogStepRequired": "Select a genre and narrative tone from the catalog to continue.",
    "catalogEmpty": "The style catalog is empty. Contact an administrator or run the catalog seed.",
    "useCatalogStyles": "Catalog styles",
    "useCatalogStylesHint": "Genre, narrative tone, and visual medium are injected into every generation. You can create a blank project without them.",
    "blankStylesSummary": "No styles",
    "summaryStyles": "Styles:",
    "uncategorizedGroup": "Uncategorized",
    "mediumSelectButton": "Choose visual medium",
    "mediumSkip": "No style",
    "mediumSkipped": "No style",
    "mediumModalTitle": "Choose visual medium",
    "mediumNoImage": "No preview",
    "mediumModalClose": "Close",
    "mediumPreviewSelect": "Select",
    "mediumNoResults": "Nothing found",
    "textGenerationLabel": "Text (structure, shots)",
    "textProviderChatGpt": "ChatGPT via n8n",
    "storyboardImagesLabel": "Storyboard images",
    "videoPerShotsLabel": "Video per shots",
    "coverLabel": "Project cover",
    "charactersRefLabel": "Characters (reference)",
    "locationsRefLabel": "Locations (reference)",
    "geminiModelLabel": "Gemini model",
    "veoModelLabel": "Veo model",
    "defaultFromStudio": "Default (Studio → AI)",
    "defaultFromStudioShort": "Default from Studio",
    "wanModelForProject": "Wan 2.7 image — project model",
    "qwenModelForProject": "Qwen Image — project model",
    "wanModelForCover": "Wan 2.7 Image — cover model",
    "qwenModelForCover": "Qwen Image — cover model",
    "wanModelForCharacters": "Wan 2.7 Image — characters model",
    "qwenModelForCharacters": "Qwen Image — characters model",
    "wanModelForLocations": "Wan 2.7 Image — locations model",
    "qwenModelForLocations": "Qwen Image — locations model",
    "modelLabel": "Model",
    "resolutionLabel": "Resolution",
    "generateSyncedAudio": "Generate synchronized audio (Seedance / BytePlus)",
    "defaultSeedance": "Default (seedance-2.0)",
    "providerKling": "Kling",
    "providerGptImageN8n": "GPT Image via n8n",
    "providerQwenImage": "Qwen Image",
    "providerWanImage": "Wan 2.7 Image",
    "providerOpenRouter": "OpenRouter (Nano Banana 2)",
    "providerGoogleGeminiImage": "Google Gemini (image)",
    "providerByteplusSeedream": "BytePlus Seedream",
    "providerDashscopeQwen": "DashScope Qwen Image",
    "providerDashscopeWan": "DashScope Wan 2.7 Image",
    "providerOpenRouterNano": "OpenRouter (Nano Banana 2)",
    "providerWanVideo": "WAN (i2v / r2v)",
    "providerSeedanceOpenRouter": "Seedance 2.0 (OpenRouter)",
    "providerSeedanceBytePlus": "Seedance 2.0 (BytePlus)",
    "providerGoogleVeo": "Google Veo",
    "summaryName": "Name:",
    "summaryFormat": "Format:",
    "summaryFormatValue": "{{seasons}} season(s), {{episodes}} episodes, {{duration}}s each",
    "summaryGenre": "Genre:",
    "summaryNarrativeTone": "Narrative tone:",
    "summaryVisualMedium": "Visual medium:",
    "summaryFrameFormat": "Frame format:",
    "summaryStoryboard": "Storyboard:",
    "summaryVideo": "video —",
    "summaryCover": "Cover:",
    "summaryCharacters": "characters —",
    "summaryLocations": "locations —",
    "fromStudio": "from Studio",
    "autogenHeading": "LLM autogeneration",
    "autogenHint": "Choose what to create automatically via AI. Manual fill is the default. Season and episodes are always created.",
    "scenesShots": "Scenes and shots —",
    "characters": "Characters —",
    "locations": "Locations —",
    "modeAi": "AI (via LLM)",
    "modeManual": "manual",
    "afterCreateWithAutogen": "After creation, background generation will start: season, episodes{{scenes}}{{characters}}{{locations}}. Progress is shown in the jobs widget. Storyboard and video are generated separately.",
    "afterCreateManual": "After creation, season and episodes will be created. Scenes, shots, characters and locations you fill manually in workspace.",
    "autogenScenes": ", scenes and shots",
    "autogenCharacters": ", characters",
    "autogenLocations": ", locations",
    "back": "Back",
    "next": "Next",
    "creating": "Creating…",
    "createAndGenerate": "Create and generate",
    "createProject": "Create project"
  },
  "feed": {
    "title": "Feed",
    "headTitle": "Studio feed",
    "beta": "beta",
    "classicView": "Classic view",
    "openFeed": "Feed",
    "markRead": "mark as read",
    "studio": "Whole studio",
    "navSearch": "Find a project",
    "tabs": {
      "all": "All",
      "review": "Needs decision",
      "ready": "Ready",
      "generations": "Generations",
      "tasks": "Tasks",
      "team": "Team"
    },
    "attention": {
      "lead": "Waiting for you:",
      "shots_one": "{{count}} shot in review",
      "shots_other": "{{count}} shots in review",
      "assets_one": "{{count}} asset in review",
      "assets_other": "{{count}} assets in review",
      "tasks_one": "{{count}} task · due {{when}}",
      "tasks_other": "{{count}} tasks · due {{when}}",
      "whenOverdue": "passed",
      "whenToday": "today",
      "whenTomorrow": "tomorrow",
      "balanceOut": "balance is out",
      "balanceLow_one": "balance lasts {{count}} more day",
      "balanceLow_other": "balance lasts {{count}} more days",
      "balanceUnderDay": "balance won't last a day",
      "topUp": "top up"
    },
    "running": {
      "title": "Generating now · {{count}}",
      "hint": "updates automatically",
      "queued": "queued",
      "stop": "Stop",
      "stopConfirm": "Force-stop “{{label}}”? The generation will be cancelled and the balance hold released. Use it for stuck jobs that never finish on their own.",
      "stopFailed": "Could not stop the generation",
      "stale": "no progress for a while"
    },
    "days": {
      "today": "Today",
      "yesterday": "Yesterday"
    },
    "event": {
      "someone": "Someone",
      "you": "You",
      "assistant": "Assistant",
      "shotFrames_one": "generated {{count}} frame",
      "shotFrames_other": "generated {{count}} frames",
      "shotVideos_one": "generated {{count}} video",
      "shotVideos_other": "generated {{count}} videos",
      "canvasItems_one": "generated {{count}} image on the canvas",
      "canvasItems_other": "generated {{count}} images on the canvas",
      "canvasVideos_one": "generated {{count}} video on the canvas",
      "canvasVideos_other": "generated {{count}} videos on the canvas",
      "scene": "Scene {{number}}",
      "sceneTitled": "Scene {{number}} “{{title}}”",
      "reviewWaiting_one": "{{count}} needs a decision",
      "reviewWaiting_other": "{{count}} need a decision",
      "checkShots_one": "Review {{count}} shot",
      "checkShots_other": "Review {{count}} shots",
      "openCanvas": "Open canvas",
      "more": "+{{count}}",
      "failure": "Failed: {{what}}",
      "failureSeries": "Failed {{count}} times in a row: {{what}}",
      "retryHint": "open it and run again",
      "openJob": "Open",
      "assembly": "Episode {{label}} assembled",
      "assemblyNoLabel": "Episode assembled",
      "watch": "Watch",
      "download": "Download",
      "assets": {
        "character_one": "New character",
        "character_other": "New characters · {{count}}",
        "location_one": "New location",
        "location_other": "New locations · {{count}}",
        "prop_one": "New prop",
        "prop_other": "New props · {{count}}"
      },
      "openAssets": "Open",
      "taskAssigned": "assigned you a task",
      "taskMentioned": "mentioned you in a task",
      "taskDue": "due {{date}}",
      "taskCreated_one": "created a task",
      "taskCreated_other": "created {{count}} tasks",
      "taskCreatedMore_one": "and {{count}} more",
      "taskCreatedMore_other": "and {{count}} more",
      "taskToYou": "to you",
      "openTask": "Open task",
      "memberJoined": "joined the studio",
      "addToProject": "Members",
      "canvasFallback": "Canvas"
    },
    "empty": {
      "title": "All quiet",
      "text": "Generations, assemblies, tasks and assistant actions across the studio's projects will show up here."
    },
    "loadingMore": "Loading more…",
    "end": "No earlier events",
    "loadMore": "Load more",
    "loadFailed": "Failed to load — try again",
    "filterEmpty": "No such events in this period",
    "start": {
      "modes": {
        "project": "New project",
        "canvas": "Canvas"
      },
      "examples": "For example",
      "project": {
        "intro": "Describe what you want to make. The assistant will propose a project — format, characters, locations and first scenes. Nothing is created until you confirm.",
        "placeholder": "Story, characters, mood, how many episodes or minutes",
        "format": "Format:",
        "formatAuto": "assistant decides",
        "submit": "Propose a project",
        "message": "Propose a project for this idea:\n\n{{idea}}",
        "messageTyped": "Propose a project, format — {{format}}, for this idea:\n\n{{idea}}",
        "examples": {
          "camp": "Camp counselors in 1987 hunt for a missing bugle. 5 one-minute episodes, tense and funny.",
          "robot": "A delivery robot and hedgehogs save a winter delivery on the Arbat. 2 minutes.",
          "coffee": "Three reels for a coffee shop: a robot barista learns latte art."
        },
        "noAssistant": "You can also skip the assistant —",
        "wizard": "project wizard"
      },
      "canvas": {
        "intro": "Frames and videos without a project. Everything is saved to the company canvas — any frame can start a project later.",
        "examples": {
          "street": "Night street in old Moscow in the snow, a delivery robot by a café window, warm shop lights.",
          "kolobok": "Kolobok cooling on a windowsill, Russian picture-book illustration.",
          "colonel": "A colonel in his office laughs and twirls a pencil, 1980s, 5 seconds."
        },
        "results": "Results go to the",
        "board": "company canvas"
      }
    },
    "navFavorites": "Favorites",
    "navOthers": "Others",
    "navAll": "Projects",
    "navMore": "Show {{count}} more",
    "navNothing": "No projects found",
    "navMoreOf": "Show {{count}} more · {{total}} left"
  },
  "review": {
    "title": "Shot review",
    "position": "{{index}} of {{total}}",
    "close": "Close review",
    "prev": "Previous shot",
    "next": "Next shot",
    "loading": "Loading the shot…",
    "shot": "Shot {{label}}",
    "scene": "Scene {{number}} “{{title}}”",
    "seconds_one": "{{count}} s",
    "seconds_other": "{{count}} s",
    "openShot": "open shot",
    "current": "current",
    "versionBadge": "version {{number}}",
    "prompt": "Prompt",
    "promptExpand": "show full prompt",
    "promptCollapse": "collapse prompt",
    "kinds": {
      "storyboard": "frame",
      "video": "video"
    },
    "tabs": {
      "storyboard": "Frame · {{count}}",
      "video": "Video · {{count}}"
    },
    "versionsTitle": {
      "storyboard": "Frame versions · {{count}}",
      "video": "Video versions · {{count}}"
    },
    "empty": {
      "storyboard": "The shot has no frames yet.",
      "video": "The shot has no video yet."
    },
    "states": {
      "draft": "draft",
      "generated": "generated",
      "in_review": "in review",
      "approved": "approved",
      "needs_changes": "needs changes",
      "locked": "locked",
      "failed": "failed"
    },
    "compare": {
      "start": "compare",
      "done": "done",
      "side": "Side by side",
      "wipe": "Wipe",
      "hint": "Pick two versions to compare.",
      "playBoth": "Play both",
      "pauseBoth": "Pause",
      "fromStart": "From start"
    },
    "tasks": {
      "title": "Shot tasks",
      "empty": "No tasks for this shot — “Redo” will create one in the tracker.",
      "comments_one": "{{count}} comment",
      "comments_other": "{{count}} comments",
      "closesOnApprove": "closes on “Approve”",
      "add": "+ task",
      "newPlaceholder": "What to do — e.g. add a scarf",
      "create": "Create"
    },
    "redoAction": "Redo",
    "approveAction": "Approve",
    "approved": "Shot {{label}} approved",
    "queue": "Queue · shots in review across your projects",
    "redo": {
      "whatToFix": "What to fix",
      "placeholder": "What is wrong and how it should be — goes to the task or the assistant",
      "chips": {
        "light": "Light",
        "composition": "Composition",
        "character": "Character off-model",
        "style": "Wrong style"
      },
      "notes": {
        "light": "Light: ",
        "composition": "Composition: ",
        "character": "Character doesn't match the reference: ",
        "style": "Style doesn't match the project: "
      },
      "previous": "Previous decision: “{{comment}}”",
      "who": "Who redoes it",
      "routes": {
        "assistant": {
          "title": "Shot assistant",
          "text": "Gets the task and regenerates right away. The new version returns to the queue."
        },
        "person": {
          "title": "A person — via a task",
          "text": "The comment goes to the tracker; the assignee is notified."
        }
      },
      "reopen": "Return {{key}} to work",
      "reopenHint": "comment goes to the task",
      "newTask": "New task",
      "versionAuthor": "version author",
      "attached": "Attached",
      "attachedValue": "{{version}} and a link to shot {{shot}}",
      "cancel": "Cancel",
      "statusHint": "the shot becomes “Needs changes”",
      "submitAssistant": "Send to assistant",
      "submitReopen": "Return to work",
      "submitTask": "Create task",
      "done": {
        "person": "Task {{key}} is in the tracker",
        "assistant": "Task {{key}} sent to the shot assistant"
      }
    },
    "queueEmpty": "No shots are waiting for review.",
    "asset": {
      "title": "Asset review",
      "kinds": {
        "character": "character",
        "location": "location",
        "prop": "prop"
      },
      "inShots_one": "in {{count}} shot",
      "inShots_other": "in {{count}} shots",
      "open": {
        "character": "open character",
        "location": "open location",
        "prop": "open prop"
      },
      "slots": {
        "reference": "Reference",
        "portrait": "Portrait",
        "sheet": "Character sheet",
        "emotions": "Emotions",
        "three_quarter": "3/4 view",
        "north": "North",
        "south": "South",
        "east": "East",
        "west": "West",
        "topview": "Top",
        "front": "Front view"
      },
      "versionsTitle": "Versions · {{slot}} · {{count}}",
      "empty": "The asset has no images yet.",
      "origins": {
        "generated": "generated",
        "uploaded": "uploaded"
      },
      "afterApprove": "After approval",
      "usage_one": "becomes the reference for {{count}} shot",
      "usage_other": "becomes the reference for {{count}} shots",
      "withFrames_one": "{{count}} of them already has a frame",
      "withFrames_other": "{{count}} of them already have frames",
      "assistant": {
        "character": "Characters assistant",
        "location": "Locations assistant",
        "prop": "Props assistant"
      },
      "attachedValue": "{{what}} and a mention of “{{name}}”",
      "approved": "“{{name}}” approved",
      "queue": "Queue · assets in review across your projects",
      "queueEmpty": "No assets are waiting for review.",
      "tasksTitle": "Asset tasks",
      "tasksEmpty": "No tasks — “Redo” creates one in the tracker; tasks that mention the asset show up here.",
      "statusHint": "the asset becomes “Needs changes”"
    },
    "media": {
      "unavailable": "The file is unavailable.",
      "openCanvas": "Open on the canvas",
      "openFlow": "Open in the flow",
      "flowVideos": "Flow videos · {{count}}",
      "flowFrames": "Flow frames · {{count}}",
      "openAssembly": "Open in assembly",
      "model": "Model",
      "references": "References",
      "format": "Format",
      "loading": "Loading inputs…"
    }
  }
}
